import { render, staticRenderFns } from "./ClientQuotes.vue?vue&type=template&id=ed229838&scoped=true"
import script from "./ClientQuotes.vue?vue&type=script&lang=js"
export * from "./ClientQuotes.vue?vue&type=script&lang=js"
import style0 from "./ClientQuotes.vue?vue&type=style&index=0&id=ed229838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed229838",
  null
  
)

export default component.exports